///
/// Copyright (c) 2017-present, Siklu Ltd.
/// All rights reserved.
///

import { createAction, props } from '@ngrx/store';
import { PlannerEulaDTO } from '../../../generated/shared-types.model';

export const getEula = createAction('[EULA] Get EULA');

export const uploadEula = createAction('[EULA] Upload New Eula', props<{ file: File }>());

export const setEula = createAction('[EULA] Set EULA', props<{ eula: PlannerEulaDTO }>());

export const acceptEula = createAction('[EULA] Accept EULA');

export const checkAcceptEula = createAction('[EULA] Check Accept EULA', props<{ isAccept: boolean }>());

export const closeEulaUpdateDialog = createAction('[EULA] Close Eula Update Dialog');
